<script>
import options from './PersonalDonationStep3.options'
export default options
</script>

<template>
  <article class="kb-personal-donation-step3">
    <section class="kb-personal-donation-step3__hero">
      <div class="kb-personal-donation-step3__hero__title-wrapper">
        <div class="kb-personal-donation-step3__hero__hero-title-circle">
          <div class="kb-personal-donation-step3__hero__hero-title-icon">
            <svg
              viewBox="0 0 22 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.7998 12L8.6998 19.2L20.1998 0.799988"
                stroke="white"
                stroke-width="2.3"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <h1 class="kb-personal-donation-step3__hero__title-wrapper__title">
          {{ getLabel('personalDonationStep3__title' ) }}
        </h1>
      </div>
      <div class="kb-personal-donation-step3__breaker">
        <svg viewBox="0 0 81 11" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z"
          />
        </svg>
      </div>
      <p class="kb-personal-donation-step3__success-text">
        {{ getLabel('personalDonationStep3_text') }}
      </p>
    </section>
    <div class="kb-personal-donation-step3__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z"
        />
      </svg>
    </div>

    <div class="kb-personal-donation-step3__button-container">
      <div class="kb-personal-donation-step3__button-wrapper">
        <a
          :href="linkToInformationHowDonationBenefits"
          class="kb-button kb-button--full-color-spot kb-personal-donation-step3__kb-button--full-color-spot"
          >{{ getLabel('personalDonationStep3_readBenefits') }}</a
        >
      </div>
    </div>
  </article>
</template>
